import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ValidatorService} from '../../../../services/validator.service';
import {DomainMetadataVO} from '../../../../generate/TopLevelDomainVO';
import {ErrorVO} from '../../../../generate/ErrorVO';
import {UtilService} from '../../../../util/util.service';
import {CommonDatePipe} from '../../../../pipes/common-date.pipe';
import {whitelistCharacterValidator} from '../../../../validators/valid-character-validator.directive';

@Component({
  selector: 'meta-data-edit',
  templateUrl: './meta-data-edit.component.html',
  styleUrls: ['./meta-data-edit.component.scss']
})
export class MetaDataEditComponent implements OnInit {


  @Input()
  newDelegation: boolean;

  @Input()
  tldMetadata: DomainMetadataVO;

  @Input()
  domainType: any;

  @Input()
  domainStatus: any;

  @Output()
  metadataOutPut = new EventEmitter<DomainMetadataVO>();

  @Output()
  cancelOutPut = new EventEmitter<boolean>();

  editMetadataForm: FormGroup;

  errors: ErrorVO;

  commonDatePipe: CommonDatePipe;
  minDate: string;
  defaultDate: string;

  get countryName(): FormControl { return this.editMetadataForm.get('countryName') as FormControl; }
  get description(): FormControl { return this.editMetadataForm.get('description') as FormControl; }
  get ianaCode(): FormControl { return this.editMetadataForm.get('ianaCode') as FormControl; }

  constructor(private formBuilder: FormBuilder, private validator: ValidatorService, private util: UtilService) {
  }

  ngOnInit() {
    this.commonDatePipe = new CommonDatePipe(this.util);
    this.minDate = this.commonDatePipe.transform(new Date().toISOString(), true);
    this.defaultDate = this.commonDatePipe.transform(this.tldMetadata.phaseout);

    this.createForm();
  }

  cancel() {
    this.cancelOutPut.emit(true);
  }


  onSubmit() {
    const formValue = this.editMetadataForm.value;
    const mofifiedMetadata = Object.create(this.tldMetadata);

    mofifiedMetadata.countryName = this.util.returnNullIfEmpty(formValue.countryName);
    mofifiedMetadata.description = this.util.returnNullIfEmpty(formValue.description);
    mofifiedMetadata.specialInstructions = this.util.returnNullIfEmpty(formValue.specialInstructions);
    mofifiedMetadata.ianaCode = this.util.returnNullIfEmpty(formValue.ianaCode);
    mofifiedMetadata.caretaker = formValue.caretaker;
    mofifiedMetadata.specialReview = formValue.specialReview;

    console.log(formValue);
    if (formValue.phaseout && formValue.phaseout !== '' && formValue.phaseout.length != 0) {
      mofifiedMetadata.phaseout = this.commonDatePipe.transform(new Date(formValue.phaseout).toISOString(), true);
    } else {
      mofifiedMetadata.phaseout = null;
    }

    this.metadataOutPut.emit(mofifiedMetadata);


  }

  displayValidationError(controlName: string): boolean {
    return this.editMetadataForm.contains(controlName)
      && !this.editMetadataForm.get(controlName).valid
      && this.editMetadataForm.get(controlName).touched;
  }

  displayServerValidationError(field: string): string[] {
    const error: ErrorVO = this.util.getFieldError(field, this.errors);
    if (error != null) {
      return error.errorMessages;
    }
  }

  private createForm() {
    if (this.tldMetadata == null) {
      this.tldMetadata = {};
    }
    this.editMetadataForm = this.formBuilder.group({
      countryName: [this.tldMetadata.countryName, [whitelistCharacterValidator]],
      description: [this.tldMetadata.description, [whitelistCharacterValidator]],
      specialInstructions: [this.tldMetadata.specialInstructions],
      ianaCode: [this.tldMetadata.ianaCode, [whitelistCharacterValidator]],
      caretaker: [this.tldMetadata.caretaker],
      specialReview: [this.tldMetadata.specialReview],
      phaseout: [this.tldMetadata.phaseout ? this.commonDatePipe.transform(this.tldMetadata.phaseout, true) : '']
    });
  }

}
